var dataModel = {
  1: {
    'apiEndpoint': 'https://api.channelsight.com/api/1.44/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2302',
    'nextProd': 'PIMM\'S SUNDOWNER',
    'retailers': {},
    'hero': {
      'h1': 'SUMMER&nbsp;IS',
      'p': 'ENJOY TOGETHER,<span class="hero__br"></span> WHATEVER THE WEATHER',
      'btnBg': '#ffffff',
      'btnColor': '#B1001B',
      'btnArrow': './misc/arrow--red.svg',
      'mobile': {
        'img': '',
        'prod': '',
        'cta': ''
      },
      'desktop': {
        'img': '',
        'prod': '',
        'cta': ''
      }
    }
  },
  2: {
    'apiEndpoint': 'https://api.channelsight.com/api/1.44/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2305',
    'nextProd': 'PIMM\'S NO.1',
    'retailers': {},
    'hero': {
      'btnBg': '',
      'h1': 'SUNSET&nbsp;IS',
      'p': 'WHEN THE EVENING HITS,<span class="hero__br"></span> IT’S TIME FOR A SPRITZ',
      'btnBg': '#A51329',
      'btnArrow': './misc/arrow--white.svg',
      'btnColor': '#ffffff',
      'mobile': {
        'img': '',
        'prod': '',
        'cta': ''
      },
      'desktop': {
        'img': '',
        'prod': '',
        'cta': ''
      }
    }
  }
}


export { dataModel as default };